import styled from "styled-components"
import theme from "../../themes"

const TextField = styled.input`
  font-size: ${theme.main.sizes.typography.mobile.p};
  border: 0;
  border-bottom: 2px solid ${props => (props.error === true ? "red" : "black")};
  background: none;
  padding: 8px 0px;
  box-sizing: border-box;
  margin-bottom: 0;
  outline: none;
  -webkit-border-radius: 0;
  border-radius: 0;
  width: 100%;
`

export default TextField
